import { Textarea } from 'components/Textarea/Textarea';

import { Field } from './Field/Field';

type Props = {
  name: string;
  label?: string;
  description?: string;
  message?: string;
  'aria-label'?: string;
  'data-qa-id'?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUpdateValue?: (...args: Array<any>) => any;
  accept?: string;
  disabled?: boolean;
  type: 'FILE' | 'URL' | 'TEXT';
};

export function RequestedTextUserField({
  name,
  label,
  description,
  onUpdateValue,
  'data-qa-id': qaId,
  type,
  disabled,
  ...props
}: Props) {
  if (type !== 'TEXT') return null;
  const subName = `${name}.${type.toLowerCase()}`;
  return (
    <Field
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      customErrorMatch={(errors) => errors[name] || errors[subName]}
      name={name}
      label={label}
      description={description}
      inputProps={props}
      renderInput={({ value, qaId: autoQaId, updateValue }) => (
        <Textarea
          disabled={disabled}
          name={name}
          data-qa-id={`${qaId || autoQaId}-hidden-input`}
          onChange={(e) => {
            const v = e.target.value;

            if (onUpdateValue) {
              onUpdateValue(
                v
                  ? {
                      type: 'TEXT',
                      text: v,
                    }
                  : null,
              );
            } else {
              updateValue(
                v
                  ? {
                      type: 'TEXT',
                      text: v,
                    }
                  : null,
              );
            }
          }}
          // @ts-expect-error TS(2769): No overload matches this call.
          type="text"
          value={value ? value.text : ''}
        />
      )}
    />
  );
}
